import { observer } from "mobx-react-lite"
import { useState } from "react"
import { rootStore } from "../StApp"

const NotifEnabler = () => {

    const [shouldVisible, setShouldVisible] = useState(true)
    const notifEnabled = rootStore.notifManager.enabled
    const uid = rootStore.mainStore.uid
    function enableNotif() {
        rootStore.notifManager.toggleNotification()
    }

    function shouldShow() {

        if (!shouldVisible)
            return 'none'

        if (uid) {
            if (!notifEnabled)
                return 'flex'
            else
                return 'none'
        }
        else
            return 'none'
    }

    return (

        <div className='flex-row notif-enabler center-align ' style={{ display: shouldShow() }} >
            <span className="material-icons-round" onClick={()=>setShouldVisible(false)} >
                clear
            </span>
            <h4 style={{ width: '55%' }} >Please enable notifications for Msgs and Matches</h4>
            <button className='button-styled button-notif' onClick={enableNotif} >ENABLE</button>
        </div>

    )

}

export default observer(NotifEnabler)